import { QuotationRepoImpl } from "domain/repository/QuotationSetting/QuotationRepoImpl";
import { useQuotationTracked } from "presentation/store/QuotationSetting/QuotationProvider";
import { QuotationVM } from "presentation/viewModel/QuotationSetting/QuotationVM";
import { useMemo } from "react";

export const useQuotationVM = () => {
    const [, setQuotationState] = useQuotationTracked();
    const quotationVM = useMemo(() =>
        QuotationVM({
            dispatch: [setQuotationState],
            repo: QuotationRepoImpl(),
        }), [setQuotationState])

    return quotationVM
}